var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoodauthority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 0.376953C27.0089 0.376953 28.2321 1.60018 28.2321 3.1091V6.89865C33.9906 7.51903 39.3975 10.087 43.5312 14.2207C48.3134 19.0029 51 25.4889 51 32.252C51 33.7012 50.4243 35.091 49.3995 36.1158C48.3748 37.1405 46.9849 37.7162 45.5357 37.7162H5.46429C4.01507 37.7162 2.6252 37.1405 1.60045 36.1158C0.5757 35.091 0 33.7012 0 32.252C0 25.4889 2.6866 19.0029 7.46878 14.2207C11.6025 10.087 17.0094 7.51903 22.7679 6.89865V3.1091C22.7679 1.60018 23.9911 0.376953 25.5 0.376953ZM2.84598 42.8034C1.33706 42.8034 0.113839 44.0267 0.113839 45.5356C0.113839 47.0445 1.33706 48.2677 2.84598 48.2677H48.1583C49.6672 48.2677 50.8904 47.0445 50.8904 45.5356C50.8904 44.0267 49.6672 42.8034 48.1583 42.8034H2.84598Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodauthority);
export default __webpack_public_path__ + "static/media/Food authority.ef16268e86efec3379a7a33eee86659d.svg";
export { ForwardRef as ReactComponent };